export default __webpack_public_path__ + "static/media/kitchen3-afterB-768w.09b2aaab.webp";